import React from 'react'
import { Col, Form, FormInstance, Input, Radio, Row, Select } from 'antd'
import { myStore } from 'state/store'
import { leagueEventStore } from 'state/league/leagueEvent'
import AgeGroup from './InputComps/AgeGroup'
import { X } from '@phosphor-icons/react'
import SkillLevel from './InputComps/SkillLevel'
import { infoMessage } from 'api/global'
import { CreateDivisionPayload } from 'types/league/division'
import { useUpdateDivsion } from 'api/league/LeagueCreation/leagueDivision'

interface ManageDivisionFormProps {
  form: FormInstance
}

const ManageDivisionForm: React.FC<ManageDivisionFormProps> = ({ form }) => {
  const { leagueData, setManageDivisionModal, divisionData, setDivisionData } =
    leagueEventStore(store => ({
      leagueData: store.leagueData,
      setManageDivisionModal: store.setManageDivisionModal,
      divisionData: store.divisionData,
      setDivisionData: store.setDivisionData,
    }))
  const setModalBtnLoader = myStore(store => store.setModalBtnLoader)
  const { mutate: updateDivisionMutation } = useUpdateDivsion()

  const genderLevels = [
    {
      key: 'male',
      name: 'Male',
    },
    {
      key: 'female',
      name: 'Female',
    },
    {
      key: 'coed',
      name: 'Co Education',
    },
  ]

  const formSchema = {
    name: divisionData ? divisionData.name : undefined,
    price: divisionData ? divisionData.price : undefined,
    priceType: divisionData?.priceType ?? 'team',
    ageGroupIds: divisionData ? divisionData.ageGroups?.map(age => age._id) : [],
    genders: divisionData ? divisionData.genders : [],
    skillLevelIds: divisionData ? divisionData.skillLevels?.map(skill => skill._id) : [],
    regions: divisionData ? divisionData.regions : [],
  }

  const onFinish = (values: any) => {
    if (!leagueData._id)
      return infoMessage('League is not created! Something went wrong')
    const payload: CreateDivisionPayload = { ...values }
    payload.organizationId = leagueData.organizationId

    setModalBtnLoader(true)
    updateDivisionMutation(
      { divisionId: divisionData._id, payload },
      {
        onSuccess: () => {
          setDivisionData(null)
          setModalBtnLoader(false)
          setManageDivisionModal(false)
        },
        onError: () => {
          setModalBtnLoader(false)
        },
      },
    )
  }

  return (
    <>
      <Form
        form={form}
        layout="vertical"
        initialValues={formSchema}
        onFinish={onFinish}
      >
        <Row>
          <Col span={24}>
            <label className="input-label required-input">Name</label>
            <Form.Item
              colon={false}
              name="name"
              rules={[{ required: true, message: 'Name is required' }]}
            >
              <Input placeholder="name" name="name" />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <label className="input-label required-input">Cost</label>
          </Col>
          <Col span={10}>
            <Form.Item
              colon={false}
              name="price"
              rules={[{ required: true, message: 'Price is required' }]}
            >
              <Input
                type="number"
                min={0}
                placeholder="$ 0.00"
                className="br-12"
                onWheel={e => e.currentTarget.blur()}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <label className="input-label required-input">Price type</label>
            <Form.Item
              name="priceType"
              rules={[{ required: true, message: 'Price type is required' }]}
            >
              <Radio.Group>
                <Radio value="team" className="radio">Per team</Radio>
                <Radio value="player" className="radio">Per player</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <label className="input-label required-input">Age group</label>
            <Form.Item
              name={'ageGroupIds'}
              className="form-control allergies-field "
              rules={[{ required: true, message: 'Age group is required' }]}
            >
              <AgeGroup
                data={divisionData ? divisionData.ageGroups : undefined}
                form={form}
                multiple={true}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={24} className="mt-10px">
            <label className="input-label required-input">Genders</label>
            <Form.Item
              name="genders"
              rules={[{ required: true, message: 'Gender is required' }]}
            >
              <Select
                className="h-50px select-field"
                defaultValue={divisionData ? divisionData.genders : undefined}
                mode="multiple"
                placeholder={'Select'}
              >
                {genderLevels.map((gender: { key: string; name: string }) => (
                  <Select.Option key={gender.key} value={gender.key}>
                    {gender.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={24} className="mt-10px">
            <label className="input-label required-input">Skill level</label>
            <Form.Item
              name={'skillLevelIds'}
              rules={[{ required: true, message: 'skill is required' }]}
            >
              <SkillLevel
                data={divisionData ? divisionData.skillLevels : undefined}
                form={form}
                multiple={true}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <label className="input-label">Region</label>
            <Form.Item
              colon={false}
              name="regions"
              rules={[{ required: true, message: 'Region is required' }]}
            >
              <Select
                mode="tags"
                placeholder="region"
                defaultValue={divisionData ? divisionData.regions : undefined}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  )
}

export default ManageDivisionForm
